const Summary = ({totalCost, paidToDate}) => {
  const remainingBalance = totalCost - paidToDate;
  const progressPercent = Math.round((paidToDate / totalCost) * 100);

  return (
    <div className="mx-6">
      <div className="bg-green-50/60 border border-green-100/30 rounded-2xl p-5 space-y-4">
        <h3 className="text-base font-bold text-green-800">Payment Summary</h3>

        <div className="space-y-2.5">
          <div className="flex justify-between items-center text-green-700/90 text-sm">
            <span>Total Treatment Cost</span>
            <span className="font-semibold text-green-900">${totalCost.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>

          <div className="flex justify-between items-center text-green-700/90 text-sm">
            <span>Paid to Date</span>
            <span className="font-semibold text-green-900">${paidToDate.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>

          <div className="flex justify-between items-center text-green-800 text-sm font-bold pt-1.5 border-t border-green-200/40">
            <span>Remaining Balance</span>
            <span className="text-base font-extrabold text-green-900">${remainingBalance.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>
        </div>

        <div className="pt-2">
          <div className="flex justify-between items-center text-green-800 text-sm font-medium">
            <span>Payment Progress</span>
            <span className="text-green-900 font-semibold">{progressPercent}%</span>
          </div>

          <div className="w-full bg-green-100 rounded-full h-1.5 mt-2 overflow-hidden">
            <div
              className="bg-green-600 h-full rounded-full transition-all duration-500"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary
